<template>
    <div
        class="modal !justify-start mt-8 pb-safe"
        aria-labelledby="add-card-modal-title"
        role="dialog"
        aria-modal="true"
    >
        <div class="modal-overlay" aria-hidden="true"></div>
        <div class="inner shadow">
            <a
                href="#"
                class="modal-close-btn text-orange"
                role="button"
                @click.prevent="$emit('close')"
            >
                <i class="fal fa-times"></i>
            </a>
            <header
                class="modal-header items-start p-2 bg-white border-t-4 border-solid border-t-orange rounded-t-lg"
            >
                <span v-if="!card.card"></span>
            </header>
            <div class="modal-body items-start p-8">
                <div class="sm:flex flex-col sm:items-center mb-2 md:mb-5">
                    <span v-if="card.card && card.card.image" class="mb-5">
                        <img
                            :src="`${cdnUrl}/${card.card.card_image.path}/_small/${card.card.card_image.file_name}`"
                            v-if="card.card.card_image"
                            class="mr-3 float-left max-w-[100px] lg:max-w-[150px] w-full h-auto"
                        />
                    </span>

                    <h1
                        class="text-base lg:text-2xl mb-5 capitalize"
                        v-if="card.card"
                    >
                        {{ card.card.title }}
                        <span class="text-xs ml-1" v-if="card.last_four">
                            ({{ card.last_four }})
                        </span>
                    </h1>
                    <h2 class="text-xl mb-5" v-if="!card.card">
                        Match your "{{ card.name }}" to the correct card from
                        the dropdown:
                    </h2>

                    <p class="mb-3 text-center w-full">
                        <span
                            v-if="card.card"
                            class="block w-full mb-2 text-xs"
                        >
                            Not the right card?
                            <label
                                class="text-orange hover:text-orange-light cursor-pointer"
                            >
                                Change Here
                                <input
                                    type="checkbox"
                                    class="hidden"
                                    v-model="changeCard"
                                    value="1"
                                />
                            </label>
                        </span>
                        <transition>
                            <div class="w-full lg:w-2/3 mx-auto mb-3">
                                <UserCardSearch
                                    @cardSelected="cardSelected"
                                    placeholder="Type card title"
                                    v-if="changeCard || !card.card"
                                />
                            </div>
                        </transition>

                        <span
                            v-if="changeCard || !card.card"
                            class="grid grid-cols-2 grid-rows-2 pt-2 w-full justify-items-center"
                        >
                            <label class="flex items-center justify-start mr-5">
                                <input
                                    class="form-checkbox cursor-pointer"
                                    type="checkbox"
                                    v-model="card.card_not_found"
                                    value="1"
                                />
                                <span class="flex items-center ml-1 text-xs">
                                    My card is not listed
                                    <tooltip
                                        :text="'Check this option if you are unable to find your card listed in the menu above.'"
                                    />
                                </span>
                            </label>
                        </span>
                        <transition>
                            <div
                                v-if="card.card_not_found"
                                class="pt-2 mt-8 w-full"
                            >
                                <div
                                    class="rounded-lg bg-gray-100 px-6 py-4 w-3/4 mx-auto mb-10 shadow border flex flex-wrap"
                                >
                                    <div class="mb-3 w-full">
                                        <h3
                                            class="text-xl mb-2 capitalize text-left"
                                        >
                                            {{
                                                card.card_match_request
                                                    ? 'Update Card Match Request'
                                                    : 'Missing Card Request'
                                            }}
                                        </h3>
                                        <div
                                            v-if="
                                                card.card_match_request &&
                                                card.card_match_request
                                                    .rejected &&
                                                card.card_match_request
                                                    .rejected_reason
                                            "
                                            class="mb-4 p-4 bg-red-50 border border-red-200 rounded-md"
                                        >
                                            <p class="text-sm text-red-700">
                                                This original card match was
                                                rejected for the following
                                                reason:
                                                <br />
                                                <br />
                                                "{{
                                                    card.card_match_request
                                                        .rejected_reason
                                                }}"
                                            </p>
                                        </div>
                                        <div
                                            v-if="card.card_match_request"
                                            class="mb-4 text-left"
                                        >
                                            <p class="text-sm text-gray-600">
                                                Originally submitted:
                                                {{
                                                    new Date(
                                                        card.card_match_request.created_at
                                                    ).toLocaleString()
                                                }}
                                            </p>
                                            <p
                                                class="text-sm text-gray-600 mt-2 text-left"
                                            >
                                                Need to make changes to your
                                                request? Update the details
                                                below and we'll review the new
                                                information.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="mb-3 w-1/2 pr-2">
                                        <UiInput
                                            id="card_not_found_bank"
                                            name="card_not_found_bank"
                                            label="Issuing Bank"
                                            :options="{ hideLabel: true }"
                                        >
                                            <template #input>
                                                <span
                                                    class="block w-full mb-2 text-sm text-left"
                                                >
                                                    Issuing Bank
                                                </span>
                                                <input
                                                    type="text"
                                                    class="form-input w-full mb-2"
                                                    v-model="
                                                        card.card_not_found_bank
                                                    "
                                                    placeholder="e.g. American Express"
                                                />
                                            </template>
                                        </UiInput>
                                    </div>
                                    <div class="mb-3 w-1/2 pl-2">
                                        <UiInput
                                            id="card_not_found_name"
                                            name="card_not_found_name"
                                            label="Card Name"
                                            :options="{ hideLabel: true }"
                                        >
                                            <template #input>
                                                <span
                                                    class="block w-full mb-2 text-sm text-left"
                                                >
                                                    Card Name
                                                </span>
                                                <input
                                                    type="text"
                                                    class="form-input w-full"
                                                    v-model="
                                                        card.card_not_found_name
                                                    "
                                                    placeholder="e.g. The 10xTravel Card"
                                                />
                                            </template>
                                        </UiInput>
                                    </div>
                                </div>
                                <div
                                    class="prose max-w-prose mx-auto text-sm text-left"
                                >
                                    <p>
                                        Submit as much info about the card in
                                        reference using the above inputs. Please
                                        be as accurate as possible in reference
                                        to the card name so that we can ensure
                                        we have the correct card.
                                    </p>
                                    <p>
                                        We'll then work to get this card added
                                        to our system, and you'll be notified
                                        once it's been added.
                                    </p>
                                </div>
                            </div>
                        </transition>
                    </p>
                </div>

                <div
                    class="grid grid-cols-12 gap-4 mb-3"
                    v-if="!card.card_not_found"
                >
                    <div
                        class="grid md:gap-y-0 gap-y-1 grid-cols-2 col-span-12 gap-4 lg:mb-3"
                    >
                        <h4 class="text-lg font-bold col-span-2">
                            Card Details
                        </h4>
                        <label class="mb-2 flex justify-start md:items-center">
                            <input
                                class="form-checkbox cursor-pointer"
                                type="checkbox"
                                v-model="card.ignore"
                                value="1"
                            />
                            <span class="flex ml-1 text-xs">
                                Hide this account

                                <tooltip
                                    :text="'Did we import a non credit-card account, such as a mortgage, loan, checking account, or something else that you want to hide? Check this option and we will hide this account.'"
                                    placement="right"
                                />
                            </span>
                        </label>
                        <div class="mb-2 col-span-1">
                            <label
                                class="mb-2 flex justify-start md:justify-end md:items-center"
                            >
                                <input
                                    type="checkbox"
                                    class="form-checkbox mr-2 cursor-pointer"
                                    name="product_change"
                                    value="1"
                                    v-model="card.product_changed"
                                    :checked="card.product_changed"
                                />
                                <span class="text-xs leading-tight">
                                    I Product Changed to This Card

                                    <tooltip
                                        :text="'Check this if you previously product changed from another card to this card.'"
                                        placement="left"
                                    />
                                </span>
                            </label>
                        </div>
                    </div>

                    <div
                        class="mb-2 col-span-12 lg:col-span-4"
                        v-if="users.length > 1"
                    >
                        <label>
                            <span class="block w-full mb-2 text-sm">User</span>
                            <select
                                class="form-select w-full"
                                v-model="card.user_id"
                            >
                                <option v-for="user in users" :value="user.id">
                                    {{ user.name }}
                                </option>
                            </select>
                        </label>
                    </div>
                    <div class="mb-2 col-span-12 lg:col-span-4">
                        <label>
                            <span class="block w-full mb-2 text-sm">
                                Account Type
                            </span>
                            <select
                                id="card-account-type"
                                class="form-select w-full validate"
                                name="choose_card"
                                v-model="accountType"
                            >
                                <option value="">
                                    Select Account Type ...
                                </option>
                                <option value="cardholder">Cardholder</option>
                                <option value="authorized_user">
                                    Authorized User
                                </option>
                            </select>
                        </label>
                    </div>

                    <div
                        class="mb-2 col-span-6 lg:col-span-4"
                        v-show="!card.product_changed"
                    >
                        <label>
                            <span class="block w-full mb-2 text-sm">
                                Date Opened
                            </span>
                            <UiInput
                                id="date_opened"
                                name="date_opened"
                                label="Date Opened"
                                placeholder="Select Date ..."
                                :options="{
                                    icon: 'calendar',
                                    hideLabel: true,
                                }"
                            >
                                <template #input>
                                    <flat-pickr
                                        id="date-opened"
                                        :config="dateConfig"
                                        class="form-input date-picker flatpickr-input active border shadow-sm pr-9 pl-10 w-full validat disabled:cursor-not-allowed"
                                        v-model="card.date_opened"
                                        placeholder="Select Date ..."
                                        :disabled="card.opened_long_ago"
                                    ></flat-pickr>
                                </template>
                            </UiInput>
                        </label>
                        <div class="pt-3">
                            <label class="flex items-center">
                                <input
                                    type="checkbox"
                                    class="form-checkbox mr-1 cursor-pointer"
                                    name="opened_long_ago"
                                    value="1"
                                    v-model="card.opened_long_ago"
                                    :checked="card.opened_long_ago"
                                />
                                <span class="ml-2 leading-none text-xs">
                                    I'm not sure
                                    <br />
                                    <small>(it was a few years ago)</small>
                                </span>
                            </label>
                        </div>
                    </div>

                    <div v-if="card.card" class="col-span-4">
                        <label class="mb-2 block w-full">
                            <span class="text-sm mr-2">
                                Override Annual Fee
                            </span>
                            <input
                                type="checkbox"
                                class="form-checkbox"
                                name="user_managed_annual_fee"
                                v-model="card.user_managed_annual_fee"
                                value="1"
                            />
                        </label>
                        <UiInput
                            id="annual_fee"
                            name="annual_fee"
                            label="Annual Fee"
                            :options="{ hideLabel: true }"
                        >
                            <template #input>
                                <label
                                    class="flex items-center"
                                    :class="{
                                        'bg-gray-100 justify-between':
                                            card.user_managed_annual_fee,
                                    }"
                                    style="margin-top: -2px"
                                >
                                    <span
                                        class="text-sm pl-3 h-10 flex items-center"
                                    >
                                        Annual Fee:
                                    </span>
                                    <input
                                        type="number"
                                        class="form-input w-32 text-right"
                                        name="annual_fee"
                                        v-model="annualFee"
                                        pattern="[0-9]"
                                        @keydown="sanitizeNumber"
                                        @input="sanitizeNumber"
                                        step="1"
                                        :placeholder="
                                            card.card
                                                ? card.card.annual_fee
                                                : '00'
                                        "
                                        v-if="card.user_managed_annual_fee"
                                    />
                                    <span
                                        class="pl-3"
                                        v-if="!card.user_managed_annual_fee"
                                    >
                                        ${{ card.card.annual_fee }}
                                    </span>
                                </label>
                            </template>
                        </UiInput>
                    </div>

                    <UiInput
                        id="last_four"
                        name="last_four"
                        label="Last Four"
                        :options="{ hideLabel: true }"
                        class="mb-2 col-span-6 lg:col-span-4"
                        v-if="!card.member_guid"
                    >
                        <template #input>
                            <label>
                                <span class="block w-full mb-2 text-sm">
                                    Last Digits of Card
                                </span>
                                <input
                                    type="text"
                                    class="form-input w-full"
                                    name="last_four"
                                    v-model="card.last_four"
                                    placeholder="#####"
                                    v-maska
                                    data-maska="#####"
                                />
                            </label>
                        </template>
                    </UiInput>

                    <UiInput
                        id="credit_limit"
                        name="credit_limit"
                        label="Credit Limit"
                        :options="{ hideLabel: true }"
                        class="mb-2 col-span-6 lg:col-span-4"
                    >
                        <template #input>
                            <label>
                                <span class="block w-full mb-2 text-sm">
                                    Credit Limit
                                </span>
                                <VueNumberFormat
                                    class="form-input w-full"
                                    v-model:value="card.credit_limit"
                                    :options="{ prefix: '$', precision: 2 }"
                                    placeholder="$XX,XXX..."
                                    min="0"
                                ></VueNumberFormat>
                            </label>
                        </template>
                    </UiInput>

                    <div class="mb-2 col-span-6 lg:col-span-4">
                        <div class="flex flex-col">
                            <span class="block w-full mb-2 text-sm">
                                Card Status
                            </span>
                            <div class="mx-0 my-1 w-24">
                                <!-- Start -->
                                <div class="flex items-center">
                                    <span class="text-xs">Closed</span>
                                    <button
                                        id="card-status"
                                        type="button"
                                        class="relative ml-2 mr-2 inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                                        @click="toggleCardStatus"
                                        :class="{
                                            'bg-orange': cardStatus === 'open',
                                            'bg-gray-200':
                                                cardStatus === 'closed',
                                        }"
                                        role="switch"
                                        aria-checked="true"
                                        aria-labelledby="privacy-option-1-label"
                                        aria-describedby="privacy-option-1-description"
                                    >
                                        <input
                                            type="text"
                                            class="hidden"
                                            v-model="cardStatus"
                                            name="card_status"
                                        />
                                        <span
                                            aria-hidden="true"
                                            class="inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                            :class="{
                                                'translate-x-5':
                                                    cardStatus === 'open',
                                                'translate-x-0':
                                                    cardStatus === 'closed',
                                            }"
                                        ></span>
                                        <i
                                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                                            :class="{
                                                'opacity-100 delay-300':
                                                    cardStatus === 'open',
                                                'opacity-0':
                                                    cardStatus === 'closed',
                                            }"
                                        ></i>
                                    </button>
                                    <span class="text-xs">Open</span>
                                </div>
                                <!-- End -->
                            </div>
                        </div>
                    </div>

                    <div
                        class="mb-2 col-span-6 lg:col-span-4"
                        v-show="card.card_status === 'closed'"
                    >
                        <label>
                            <span class="block w-full mb-2 text-sm">
                                Date Closed
                            </span>
                            <UiInput
                                id="date_closed"
                                name="date_closed"
                                label="Date Closed"
                                placeholder="Select Date ..."
                                :options="{
                                    icon: 'calendar',
                                    hideLabel: true,
                                }"
                            >
                                <template #input>
                                    <flat-pickr
                                        :config="dateConfig"
                                        class="form-input date-picker flatpickr-input active border shadow-sm pr-9 w-full"
                                        v-model="card.date_closed"
                                        placeholder="Select Date ..."
                                    ></flat-pickr>
                                </template>
                            </UiInput>
                        </label>
                    </div>
                </div>

                <div
                    class="grid grid-cols-12 gap-4 mb-8 w-full border-b border-gray-200"
                    v-show="card.product_changed && !card.card_not_found"
                ></div>

                <div
                    class="grid grid-cols-12 gap-4 mb-3"
                    v-show="card.product_changed && !card.card_not_found"
                >
                    <h4 class="text-lg font-bold mb-1 col-span-12">
                        Product Change Details
                    </h4>
                    <h5 class="text-base font-semibold mb-2 col-span-12">
                        Original Product Details
                    </h5>
                    <div
                        class="mb-2 col-span-12 lg:col-span-4"
                        v-show="card.product_changed"
                    >
                        <p
                            class="text-sm mb-1 leading-tight"
                            v-if="card.original_card"
                        >
                            Current Original Card
                        </p>
                        <UserCardSearch
                            label="Which Original Card Did You Open?"
                            @cardSelected="originalCardSelected"
                            @clearCurrentCard="clearCurrentCard"
                            placeholder="Type card title"
                            :current-card="card.original_card"
                        />
                    </div>

                    <div class="mb-2 col-span-6 lg:col-span-4">
                        <label>
                            <span
                                class="block w-full mb-2 text-sm leading-tight"
                            >
                                Date Original Product was Opened
                            </span>
                            <UiInput
                                id="product_changed_date_opened"
                                name="product_changed_date_opened"
                                label="Date Original Product was Opened"
                                placeholder="Select Date ..."
                                :options="{
                                    icon: 'calendar',
                                    hideLabel: true,
                                }"
                            >
                                <template #input>
                                    <flat-pickr
                                        :config="dateConfig"
                                        class="form-input date-picker flatpickr-input active border shadow-sm pr-9 pl-10 w-full"
                                        v-model="
                                            card.product_changed_date_opened
                                        "
                                        placeholder="Select Date ..."
                                    ></flat-pickr>
                                </template>
                            </UiInput>
                        </label>
                    </div>

                    <div class="mb-2 col-span-6 lg:col-span-4">
                        <label>
                            <span
                                class="block w-full mb-2 text-sm leading-tight"
                            >
                                Date Product was Changed
                            </span>
                            <UiInput
                                id="product_changed_date"
                                name="product_changed_date"
                                label="Date Product was Changed"
                                placeholder="Select Date ..."
                                :options="{
                                    icon: 'calendar',
                                    hideLabel: true,
                                }"
                            >
                                <template #input>
                                    <flat-pickr
                                        :config="dateConfig"
                                        class="form-input date-picker flatpickr-input active border shadow-sm pr-9 pl-10 w-full"
                                        v-model="card.product_changed_date"
                                        placeholder="Select Date ..."
                                    ></flat-pickr>
                                </template>
                            </UiInput>
                        </label>
                    </div>
                    <h5 class="text-base font-semibold mb-2 col-span-12">
                        Original Product Welcome Bonus Info
                    </h5>
                    <div
                        class="mb-2 col-span-6 lg:col-span-4"
                        v-show="card.original_card_id"
                    >
                        <label>
                            <span
                                class="block w-full mb-2 text-sm leading-tight"
                            >
                                When Did You Earn the Bonus On The
                                <span v-if="productChangedCard">
                                    {{ productChangedCard.title }}
                                </span>
                                ?
                            </span>
                            <UiInput
                                id="original_bonus_received_date"
                                name="original_bonus_received_date"
                                :label="`When did you receive the bonus on the ${productChangedCard?.title}?`"
                                placeholder="Select Date ..."
                                :options="{
                                    icon: 'calendar',
                                    hideLabel: true,
                                }"
                            >
                                <template #input>
                                    <flat-pickr
                                        :config="dateConfig"
                                        class="form-input date-picker flatpickr-input active border shadow-sm pr-9 pl-10 w-full disabled:cursor-not-allowed"
                                        v-model="card.original_card_bonus_date"
                                        placeholder="Select Date ..."
                                        :disabled="card.bonus_date_long_ago"
                                    ></flat-pickr>
                                </template>
                            </UiInput>
                        </label>
                        <div class="pt-3">
                            <label class="flex items-center">
                                <input
                                    type="checkbox"
                                    class="form-checkbox mr-2 cursor-pointer"
                                    name="bonus_rec"
                                    value="1"
                                    v-model="card.bonus_date_long_ago"
                                    :checked="card.bonus_date_long_ago"
                                />
                                <span class="ml-2 leading-none text-xs">
                                    I'm not sure
                                    <br />
                                    <small>(it was a few years ago)</small>
                                </span>
                            </label>
                        </div>
                    </div>

                    <UiInput
                        name="product_changed_bonus_amount"
                        id="product_changed_bonus_amount"
                        label="Original Welcome Bonus Amount"
                        :options="{ hideLabel: true }"
                        class="mb-2 col-span-12 lg:col-span-4"
                    >
                        <template #input>
                            <label>
                                <span class="block w-full mb-2 text-sm">
                                    Original Welcome Bonus Amount
                                </span>
                                <VueNumberFormat
                                    class="form-input w-full"
                                    v-model:value="
                                        card.product_changed_bonus_amount
                                    "
                                    placeholder="XXX,XXX..."
                                    min="0"
                                ></VueNumberFormat>
                            </label>
                        </template>
                    </UiInput>

                    <UiInput
                        name="product_changed_min_spend"
                        id="product_changed_min_spend"
                        label="Original Minimum Spend Amount"
                        :options="{ hideLabel: true }"
                        class="mb-2 col-span-4"
                    >
                        <template #input>
                            <label>
                                <span class="block w-full mb-2 text-sm">
                                    Original Minimum Spend Amount
                                </span>
                                <VueNumberFormat
                                    class="form-input w-full"
                                    v-model:value="
                                        card.product_changed_min_spend
                                    "
                                    :options="{ prefix: '$' }"
                                    placeholder="$X,XXX..."
                                    min="0"
                                ></VueNumberFormat>
                            </label>
                        </template>
                    </UiInput>
                </div>

                <div
                    class="grid grid-cols-12 gap-4 mb-8 w-full border-b border-gray-200"
                    v-if="!card.card_not_found && !card.product_changed"
                ></div>

                <div
                    class="grid grid-cols-12 gap-4 mb-3"
                    v-if="!card.card_not_found && !card.product_changed"
                >
                    <div class="grid grid-cols-2 col-span-12 gap-4 lg:mb-3">
                        <h4 class="text-lg font-bold mb-2 col-span-1">
                            Welcome Bonus Details
                        </h4>

                        <div class="mb-2 col-span-1" v-show="!productChanged">
                            <label class="mb-2 flex justify-end">
                                <input
                                    type="checkbox"
                                    class="form-checkbox mr-2 cursor-pointer"
                                    name="bonus_rec"
                                    value="1"
                                    v-model="card.bonus_received"
                                    :checked="card.bonus_received"
                                />
                                <span class="text-xs leading-none">
                                    Welcome Bonus Received
                                </span>
                            </label>
                        </div>
                    </div>
                    <div
                        class="mb-2 col-span-6 lg:col-span-4"
                        v-show="productChanged"
                    ></div>

                    <UiInput
                        name="bonus_amount"
                        id="bonus_amount"
                        label="Welcome Bonus Amount"
                        :options="{ hideLabel: true }"
                        class="mb-2 col-span-6 lg:col-span-4"
                    >
                        <template #input>
                            <label>
                                <span
                                    class="block w-full mb-2 text-sm leading-tight"
                                >
                                    Welcome Bonus Amount
                                </span>
                                <VueNumberFormat
                                    class="form-input w-full"
                                    v-model:value="card.bonus_amount"
                                    placeholder="XX,XXX..."
                                    min="0"
                                ></VueNumberFormat>
                            </label>
                        </template>
                    </UiInput>

                    <UiInput
                        name="minimum_spend_amount"
                        id="minimum_spend_amount"
                        label="Minimum Spend Amount"
                        :options="{ hideLabel: true }"
                        class="mb-2 col-span-6 lg:col-span-4"
                    >
                        <template #input>
                            <label>
                                <span
                                    class="block w-full mb-2 text-sm leading-tight"
                                >
                                    Minimum Spend Amount
                                </span>
                                <VueNumberFormat
                                    class="form-input w-full"
                                    v-model:value="card.minimum_spend_amount"
                                    :options="{ prefix: '$' }"
                                    placeholder="XX,XXX..."
                                    min="0"
                                ></VueNumberFormat>
                            </label>
                        </template>
                    </UiInput>

                    <div
                        class="mb-2 col-span-6 lg:col-span-4"
                        v-show="!card.bonus_received && !productChanged"
                    >
                        <label>
                            <span
                                class="block w-full mb-2 text-sm leading-tight"
                            >
                                Minimum Spend Deadline
                            </span>
                            <UiInput
                                id="min_spend_deadline"
                                name="min_spend_deadline"
                                label="Minimum Spend Deadline"
                                placeholder="Select Date ..."
                                :options="{
                                    icon: 'calendar',
                                    hideLabel: true,
                                }"
                            >
                                <template #input>
                                    <flat-pickr
                                        :config="futureDateConfig"
                                        class="form-input date-picker flatpickr-input active border shadow-sm pr-9 pl-10 w-full"
                                        v-model="card.minimum_spend_deadline"
                                        placeholder="Select Date ..."
                                    ></flat-pickr>
                                </template>
                            </UiInput>
                        </label>
                    </div>

                    <div
                        class="mb-2 col-span-6 lg:col-span-4"
                        v-show="card.bonus_received && !productChanged"
                    >
                        <label>
                            <span
                                class="block w-full mb-2 text-sm leading-tight"
                            >
                                Date Received
                            </span>
                            <UiInput
                                id="date_received"
                                name="date_received"
                                label="Date Received"
                                placeholder="Select Date ..."
                                :options="{
                                    icon: 'calendar',
                                    hideLabel: true,
                                }"
                            >
                                <template #input>
                                    <flat-pickr
                                        :config="dateConfig"
                                        class="form-input date-picker flatpickr-input active border shadow-sm pr-9 pl-10 w-full disabled:cursor-not-allowed"
                                        v-model="card.date_received"
                                        placeholder="Select Date ..."
                                    ></flat-pickr>
                                </template>
                            </UiInput>
                        </label>
                    </div>
                </div>
                <div
                    class="w-full flex justify-center"
                    v-show="errors.length > 0"
                >
                    <Errors :errors="errors" />
                </div>
            </div>
            <footer
                class="modal-footer flex flex-row-reverse px-6 justify-between bg-gray-50"
            >
                <ActionButton
                    @clicked="saveCardChanges"
                    :label="
                        this.card.card_not_found
                            ? this.card.card_match_request
                                ? this.card.card_match_request.rejected
                                    ? 'Resubmit Match Request'
                                    : 'Update Match Request'
                                : 'Submit Request'
                            : 'Save Card'
                    "
                    :loading="saveCardBtnAction"
                    :classes="'btn btn-primary !min-w-48'"
                />
                <button
                    type="button"
                    class="btn btn-secondary !w-48 !bg-gray-50"
                    @click.prevent="$emit('close')"
                >
                    Close
                </button>
            </footer>
        </div>
        <confetti :fireConfetti="fireConfetti"></confetti>
    </div>
</template>
<script>
import { mapActions, mapState } from 'pinia';
import { useWalletStore } from '@/store/wallet';
import ActionButton from '@/components/action-button.vue';
import CustomSelect from '@/components/custom-select.vue';
import Tooltip from '@/components/tooltip.vue';
import FlatPickr from 'vue-flatpickr-component';
import Errors from '@/components/errors.vue';
import Confetti from '@/components/confetti.vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import UserCardSearch from '@/components/ui/user-card-search.vue';

import { vMaska } from 'maska/vue';

export default {
    props: {
        wallet: Object,
        card: {
            type: Object,
            default: {
                account_type: 'cardholder',
                card_status: 'open',
            },
        },
        users: Array,
        banks: Array,
        user: Object,
        cards: Array,
        show: Boolean,
    },
    directives: { maska: vMaska },
    components: {
        ActionButton,
        CustomSelect,
        FlatPickr,
        Tooltip,
        Errors,
        Confetti,
        UiInput,
        UserCardSearch,
    },
    data: () => ({
        errors: [],
        saveCardBtnAction: false,
        showModal: false,
        changeCard: false,
        dateConfig: {
            dateFormat: 'm/d/Y',
            maxDate: 'today',
        },
        futureDateConfig: {
            dateFormat: 'm/d/Y',
            minDate: 'today',
        },
        showCreatedManualRewardProgramMessage: false,
    }),
    watch: {
        'card.opened_long_ago'(newVal, oldVal) {
            if (newVal) {
                this.card.date_opened = null;
            }
        },
        'card.bonus_date_long_ago'(newVal, oldVal) {
            if (newVal) {
                this.card.original_card_bonus_date = null;
            }
        },
    },
    computed: {
        productChangedCard() {
            return this.card.original_card;
        },
        annualFee: {
            get() {
                return this.card.card && !this.card.user_managed_annual_fee
                    ? this.card.card.annual_fee
                    : this.card.annual_fee;
            },
            set(value) {
                this.card.annual_fee = value;
            },
        },
        accountType: {
            get() {
                return this.card?.account_type &&
                    this.card?.account_type.length > 4
                    ? this.card.account_type
                    : '';
            },
            set(value) {
                this.card.account_type = value;
            },
        },
        cardStatus: {
            get() {
                return this.card.card_status && this.card.card_status !== ''
                    ? this.card.card_status
                    : 'closed';
            },
            set(value) {
                this.card.card_status = value;
            },
        },
        productChanged() {
            return (
                this.card.product_changed && this.card.original_card_bonus_date
            );
        },
        fireConfetti() {
            if (
                this.card.bonus_received &&
                this.card.date_received && //this.card.minimum_spend_deadline
                this.card.bonus_amount
            ) {
                return true;
            }
            return false;
        },
        cdnUrl() {
            return window.cdnUrl;
        },
    },
    methods: {
        ...mapActions(useWalletStore, ['setShowEditCardModal', 'updateCard']),
        async saveCardChanges() {
            this.saveCardBtnAction = true;
            this.errors = [];

            this.validateUpdateCardForm();

            if (this.errors.length === 0) {
                let data = {
                    card_not_found_name: this.card.card_not_found_name,
                    issuing_bank: this.card.card_not_found_bank,
                    card: this.card,
                };

                const endpoint = this.card.card_match_request
                    ? `/wallets/${this.wallet.id}/cards/${this.card.id}/match-request`
                    : `/wallets/${this.wallet.id}/cards/${this.card.id}`;

                ApiService.apiCall(endpoint, 'put', data)
                    .then((response) => {
                        if (this.card.card_match_request) {
                            this.$notify(
                                {
                                    group: 'success',
                                    title: 'Request Updated',
                                    text: "Your card match request has been updated. We'll review the new information.",
                                },
                                8000
                            );
                        } else if (
                            this.card.card_not_found &&
                            !this.card.card_not_found_notified
                        ) {
                            this.$notify(
                                {
                                    group: 'success',
                                    title: 'Request Sent',
                                    text: "Your Missing Card Request was successfully submitted. You'll hear from us soon.",
                                },
                                8000
                            );
                        }
                        this.card.card_not_found = false;
                        this.saveCardBtnAction = false;
                        this.showEditCardModal = false;
                        this.$emit('close', 'showEditCardModal');
                        this.$emit('update', {
                            card: response.data.connected_account,
                            user: this.user,
                        });
                    })
                    .catch((response) => {
                        this.$root.handleHttpStatus(response);
                        this.saveCardBtnAction = false;
                        if (response.hasOwnProperty('errors')) {
                            response.errors.forEach((el) => {
                                this.errors.push({ message: el[0] });
                            });
                        }
                        this.errors.push({
                            message: response?.response?.data?.message,
                        });
                    });
            }
        },
        cardSelected(card) {
            this.card.card_id = card.id;
            this.card.card = card;
        },
        originalCardSelected(card) {
            this.card.original_card_id = card.id;
            this.card.original_card = card;
        },
        clearCurrentCard() {
            this.card.original_card_id = null;
            this.card.original_card = null;
        },
        toggleCardStatus() {
            this.cardStatus = this.cardStatus === 'closed' ? 'open' : 'closed';
        },
        validateUpdateCardForm() {
            let $validateItems = document.querySelectorAll('.validate');
            $validateItems.forEach((item) => {
                item.classList.remove('error');
            });

            if (this.card.card_not_found) {
                if (
                    !this.card.card_not_found_name ||
                    this.card.card_not_found_name === ''
                ) {
                    this.errors.push({
                        message: 'Please enter the card suggestion.',
                    });
                    this.saveCardBtnAction = false;
                }
                if (
                    !this.card.card_not_found_bank ||
                    this.card.card_not_found_bank === ''
                ) {
                    this.errors.push({
                        message: 'Please enter the card issuing bank.',
                    });
                    this.saveCardBtnAction = false;
                }
            }

            if (
                !this.card.ignore &&
                !this.card.card_not_found &&
                (this.card.card_id === '' || !this.card.card_id)
            ) {
                this.errors.push({ message: 'Please choose a Card.' });
                document.getElementById('card').classList.add('error');
            }

            if (
                !this.card.ignore &&
                !this.card.card_not_found &&
                !this.card.account_type
            ) {
                this.errors.push({
                    message: 'Please choose a Card Account Type.',
                });
                document
                    .getElementById('card-account-type')
                    .classList.add('error');
            }

            if (!this.card.ignore) {
                if (
                    (this.card.date_opened === '' || !this.card.date_opened) &&
                    !this.card.opened_long_ago &&
                    !this.card.card_not_found &&
                    !this.card.product_changed
                ) {
                    this.errors.push({
                        message: 'Please enter the date opened.',
                    });
                    document
                        .getElementById('date-opened')
                        .classList.add('error');
                }

                if (
                    (this.card.card_status === '' || !this.card.card_status) &&
                    !this.card.card_not_found
                ) {
                    this.errors.push({
                        message: 'Please choose the card status.',
                    });
                    document
                        .getElementById('card-status')
                        .classList.add('error');
                }

                if (
                    this.card.bonus_received &&
                    !this.card.card_not_found &&
                    !this.card.product_changed
                ) {
                    if (
                        !this.card.bonus_amount ||
                        this.card.bonus_amount == 0
                    ) {
                        this.errors.push({
                            message: 'Please enter the bonus amount.',
                        });
                    }

                    if (
                        !this.card.date_received ||
                        this.card.date_received === ''
                    ) {
                        this.errors.push({
                            message: 'Please enter the bonus date received.',
                        });
                    }
                }
            }

            if (this.errors.length > 0) {
                this.saveCardBtnAction = false;
            }
        },
        sanitizeNumber(el) {
            this.annualFee = el.target.value.replace(/\D/g, '');
        },
    },
    mounted() {
        if (this.users.length === 1) {
            this.card.user_id = this.users[0].id;
        }
    },
};
</script>
<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
